'use strict';

const MSH_BI_TYPE 		= 'MASHBOARD_BI'; 

class MainTopController {

	constructor($scope, $mdSidenav, ngPopover, $rootScope, $timeout) {
		this.changeListeners		= new Set();
		this.ready 					= false;
		this.$scope 				= $scope;
		this.$rootScope 			= $rootScope;
		this.$mdSidenav				= $mdSidenav;
		this.$timeout				= $timeout;
		this.resourcePath 			= $scope.DECISYON.template.resourcePath;
		this.hideHeader 			= $scope.DECISYON.target.content.ctx.hideHeader.value;
		this.divCenterClass 		= this.hideHeader == 'true' ? "hideHeader" : "";  
		this.resourcePath 			= this.$scope.DECISYON.template.resourcePath;
		this.toNotificationBounce 	= false;
		this.toTaskBounce 			= false;
		this.ngPopover 				= ngPopover;
		this._watchListener();
		this._initializeVM(this.$scope.DECISYON.target.content.data);
		this._mainTopSettings		= new MainTopSettings(this.ngPopover, this.resourcePath);
		this.openMashBoardContent = this.openMashBoardContent;
		this.initializeSectionNavigation();
		
		$timeout(() => {
			this.ready = true;
			var event = new CustomEvent('dcy.mainCtrlStarted', {});
			rootPage.dispatchEvent(event);
		});
	}

	isReady(){
		return this.ready;
	}

	initializeSectionNavigation () {
		let _self 				= this;
		RouterAsyncBridge.getBridge().then((bridge) => {
			let navigationObject = this.getRouteFromSessionStorage(bridge);
			let isFoundRoute = navigationObject && this.navigateToRoute(bridge, navigationObject);
			if (!isFoundRoute) {
				_self.enableCentralPageBySrc(_self.$scope.DECISYON.target.content.ctx.centralPageSrc.value);
			}

		});
	}

	getRouteFromSessionStorage (bridge) {
		try {
			let LOGIN_DESTINATION_ROUTE = bridge.SESSION_STORAGE_KEYS.LOGIN_DESTINATION_ROUTE;
			let navigationObject = sessionStorage.getItem(LOGIN_DESTINATION_ROUTE);
			if (navigationObject) {
				sessionStorage.removeItem(LOGIN_DESTINATION_ROUTE);
				navigationObject = JSON.parse(navigationObject);
				let currentDate = new Date();
				let expirationDate = navigationObject.expiresAt;
				if (Date.parse(currentDate) < Date.parse(expirationDate)) {
					return navigationObject;
				}
			}
		}
		catch (e) {
			console.error('Error found getting session storage route. ' + e.message);
		}
		return undefined;
	}

	navigateToRoute(bridge, navigationObject) {
		try {
			bridge.ROUTING_MANAGER.navigateToRoute(navigationObject.match.contextName, navigationObject.match.contentData);
			return true;
		}
		catch (e) {
			console.error('navigateToRoute: error invoking routing manager. ' + e.message);
		}
		return false;
	}

	toggleSideBar () {
		this.ngPopover.close();
		this.$mdSidenav('dcy_sidebar').toggle();
	}

	closeSideBar () {
		this.ngPopover.close();
		this.$mdSidenav('dcy_sidebar').close();
	}

	_initializeVM(data) {
		this.data	= data;
	}

	_updateVM(newData) {
		_.merge(this.data, newData);
		this._triggerChangeListener();
	}

	_getHeaderTamplate() {
		return this.resourcePath + '/header/header.template.html';
	}

	_getSideBarTamplate () {
		return this.resourcePath + '/sideBar/sideBar.template.html';
	}

   _executeFnByElement(element, obj, event) {
	   return this.doAction(element, obj, event);
   }
   
   enableCentralPageBySrc(src) {
	   if(this.centralPageSrc !== src){
		this.disabledDcyTemplateContent();
		this.centralPageSrc = src;
		this.$scope.$applyAsync();
	   }
	}
	
	initializeDcyTemplateContent () {
		this.dcyTemplateContent = {
			isEnabled 	: false,
			ctx			: null,
			instance		: null
		};
	}
	
	enableDcyTemplateContent (ctx, csmlo, dpc) {
		if(!this.dcyTemplateContent){
			this.initializeDcyTemplateContent();
		}
		this.dcyTemplateContent.ctx = ctx;
		this.dcyTemplateContent.csmlo = csmlo;
		this.dcyTemplateContent.dpc = dpc;
		this.dcyTemplateContent.isEnabled = true;
		this.centralPageSrc = null;
		this.$scope.$applyAsync();
	}
	
	disabledDcyTemplateContent (ctx) {
		this.initializeDcyTemplateContent();
		this.$scope.$applyAsync();
   }
   
   onClickElement (elementInfo, obj, event) {
	   if (this._executeFnByElement(elementInfo, obj, event) != false)
		   this.closeSideBar();
   }
   
   _watchListener(){
	   	let _self = this;
		let unbindWatches = new Array();

		unbindWatches.push(_self.$scope.$watch('DECISYON.target.content.data', function(newData, oldData){
			if(!angular.equals(newData, oldData) && !Utilities.isUndefinedOrNull(oldData)){
				if(!angular.equals(newData.userButtonsInfo.task.count, oldData.userButtonsInfo.task.count)){
					_self.$scope.mainTopCtrl.toTaskBounce = true;
				}
				if(!angular.equals(newData.userButtonsInfo.notifications.count, oldData.userButtonsInfo.notifications.count)){
					_self.$scope.mainTopCtrl.toNotificationBounce = true;
				}
				_self.$scope.mainTopCtrl._updateVM(newData);
			}
		}, true));

		unbindWatches.push(_self.$scope.$watch('mainTopCtrl.centralPageSrc', function(newCentralPageSrc, oldCentralPageSrc){
			if(!angular.equals(newCentralPageSrc, oldCentralPageSrc)){
				setTimeout(() => {
					if(newCentralPageSrc && window){
						var centrale = document.getElementById('centrale');
						if(centrale){
							centrale.contentWindow.location.replace(newCentralPageSrc);
						}
					}
				});
			}
		}));
		
		_self.$scope.$on('$destroy', function () {
            for(var i = 0; i < unbindWatches.length; i++){
				unbindWatches[i]();
			}
        });
	}
   
   _triggerChangeListener(listener) {
	   this.changeListeners.forEach((listener) => {
		   listener.apply(this, arguments);
	   });
   }
   
   attachOnChangeListener(listener) {
	   if(Utilities.isFunction(listener)){
		   this.changeListeners.add(listener);
		   return true;
	   }
	   return false;
   }
   
   getIcon(elementInfo) {
	   return this._mainTopSettings.getIcon(elementInfo.action);
   }

   getColor(elementInfo) {
	   return this._mainTopSettings.getColor(elementInfo.action);
   }

   doAction(elementInfo, obj, event) {
		let params = [obj, event];
		if (elementInfo.params)
			elementInfo.params.forEach((param) => {
				params.push(param);
			});
	   return this._mainTopSettings.doAction(elementInfo, params);
   }

   doInit(elementInfo, target) {
	   let params = [this.$scope.$new(), target];
	   return this._mainTopSettings.doInit(elementInfo, params);
   }

   pushNewHistoryState(data, title, url){
	   window.history.pushState(data, title, url);
   }
   
   replaceCurrentHistoryState(data, title, url){
	   window.history.replaceState(data, title, url);
   }

}
